import { render } from "./WordsMatch.vue?vue&type=template&id=4d55b0de"
import script from "./WordsMatch.vue?vue&type=script&lang=js"
export * from "./WordsMatch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__